import React, {Fragment} from "react";
// react-router
// import "jquery/dist/jquery.min.js";
import {msalAuth} from "../../../../api/msal/MsalAuthProvider";
import $ from "jquery";
// import "jquery-ui-bundle";
import {
    StartActivity,
    GetTreeStructure,
} from "../../../common/common";
import {CommonLoading} from "react-loadingg";
import TreeChildren from "../../../catalog/sideMenu/TreeChildren";
import ColumnList from "../../../common/componet-jsons/column-list-mm.json";
import "./Variable";
import MyContext from "../../../../api/context/my-context";

import * as omnimap from "../../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "./functions/callBackFunctions";
import {CONSTS} from "../../../common/const";
import {GetActionsOfEndpointAction, InitiateProcessAction} from "../../../../api/omnimap/omnimapActions";
import {GetSelected, SetSelected} from "../../../common/tableHandler/manipulateTable";
import {DropFromSetSelectedButtonIdsIfSelected, MergeUniquely} from "../../../common/function/functions";
import {GetDataForMapWithSetSelectedCallback} from "../../../common/map/showOnMap/showOnMap";
import {MAN_MU_CONST} from "../../../../constants/ActionEnums/ManActionEnums";
import * as GC from "../../../common/common";

class Table extends React.Component {
    constructor(props) {
        super(props);
        this.wrapperRef = React.createRef();

        this.state = {
            tabName: props.tabName,
            menuName: props.menuName,
            treekey: props.treekey,
            isLoading: true,

            token: null,
            beheeractiviteit_zoeken_active: true,
            beheeractiviteit_boom_active: false,
            beheeractiviteit_plannig_active: false,
            treeList: [],
            columnList: null,
            columnListPure: null,
            columnOrderIdentification: "",
            columnOrderReference: "",
            isAlertOpen: false,
            alertMessage: "",
            setShowSelectedButton:props.setShowSelectedButton,
            measure_buttons: []
        };

        window.$mm_management_units_context = this;
    }

    handleToggleZoeken = () => {
        if (!this.state.beheeractiviteit_zoeken_active) {
            window.$mm_management_units_maat_page_number = 1;
            this.getEntityList("maatregelnames", 1, 30, this.maatregelenCallback);
        }
        document.getElementById(
            "beheeractiviteit-zoeken-item-selected"
        ).innerText = 0;
        if (!this.state.beheeractiviteit_zoeken_active) {
            this.setState({
                beheeractiviteit_zoeken_active:
                    !this.state.beheeractiviteit_zoeken_active,
                beheeractiviteit_boom_active: !this.state.beheeractiviteit_boom_active,
            });
        }
    };

    refresh_() {
        $("#cover-spin").show(0);
        $("#beheer-svg").attr("class", "maatregelen-svg");
        $("#beheer-snowflake").attr("class", "snowflake");
        window.$mm_management_units_page_number = 1;

        if (document.getElementById("beheer-filter-input-true")) {
            document.getElementById("beheer-filter-input-true").remove();
            var filterRowActive = $('<div id="beheer-filter-input-true"></div>')
                .attr({name: "true"})
                .addClass("filter-popup-r")
                .html(
                    '<label class="filter-container" id="filter-container-true">Filter op met maatregel' +
                    '<input type="checkbox" name="filter-input" id="m-filter-input-true">' +
                    '<span class="checkmark-green"></span>' +
                    "</label>"
                );
            document.getElementById("beheer-filter-input-false").remove();
            var filterRowFalse = $('<div id="beheer-filter-input-false""></div>')
                .attr({name: "false"})
                .addClass("filter-popup-r")
                .html(
                    '<label class="filter-container" id="filter-container-false">Filter op zonder maatregel' +
                    '<input type="checkbox" name="filter-input" id="m-filter-input-false">' +
                    '<span class="checkmark-red"></span>' +
                    "</label>"
                );
            $("#beheer-short-table-popup").append(filterRowActive, filterRowFalse);
        }

        window.$mm_management_units_filterCheckControl.forEach(
            (name, index) =>
                (window.$mm_management_units_filterCheckControl[index] = false)
        );

        window.$mm_management_units_context.fillTable(window.$mm_management_units_lastUsedTableFilter, 1);
    }

    //************************************

    onWarningClosed = () => {
        $("#beheeractiviteit_toevoegen").modal("hide");
        window.$mm_management_units_context.setState({isAlertOpen: false})
        window.$mm_management_units_context.savedCallBack();
    }

    savedCallBack = () => {
        window.$mm_management_units_context.refresh_();
    };

    //**********************************

    checkNumberOfWorkerRules() {
        const spin =  $("#cover-spin");
        spin.show(0)
        // const selectedIds = [];
        // $("#example")
        //     .dataTable()
        //     .$("tr.selected")
        //     .each(function () {
        //         selectedIds.push($(this).attr("rowId"));
        //     });
        //ActionListenerWorkRules(selectedIds, ["9f579fe7-e03c-4e61-ac1b-a724b1d61229"]);
        $("#beheeractiviteit_toevoegen").modal("hide");
        window.$mm_management_units_refresh();
        spin.hide(0);
    }

    handleToggleBoom = () => {
        if (!this.state.beheeractiviteit_boom_active) {
            this.setState({
                beheeractiviteit_boom_active: !this.state.beheeractiviteit_boom_active,
                beheeractiviteit_zoeken_active:
                    !this.state.beheeractiviteit_zoeken_active,
            });

            document.getElementById(
                "beheeractiviteit-zoeken-item-selected"
            ).innerText = ` ${0}`;

            if (!this.props.location) {
                this.props.location.state.isDidUpdate = "0038";
            }
            window.$mm_management_units_text_search = [];
            window.$mm_management_units_sorting = [];
            window.$mm_management_units_maat_page_number = 1;
            this.getEntityList("maatregelnames", 1, 30, this.maatregelenCallback);
        }
    };

    handlePlannig = () => {
        this.setState({
            beheeractiviteit_plannig_active:
                !this.state.beheeractiviteit_plannig_active,
        });
    };

    async fillTable(model, page_number, customResult) {
        var that = this;
        window.$mm_management_units_lastUsedTableFilter = model;
        window.$mm_management_units_scroll_change = false;
        window.$mm_management_units_Glist = [];
        // here
        let result

        if (customResult && typeof customResult === 'object'){
            result = customResult
        } else {
            result  = await omnimap.FillTableAction(
                model,
                page_number,
                window.$mm_management_units_token
            );
        }


        CallBackFunctions.FillTableCallBack(
            result,
            page_number,
            window.$mm_management_units_columnListPure
        );
    }

    /***GET ENTITY LIST***/
    getEntityList = (
        defType,
        pageNr,
        pageSize,
        successCallback,
        ids,
        text_search = [],
        sorting = []
    ) => {
        var that = this;
        let definition = window.$mm_management_units_definitionList.filter(
            (def) => def["name"] === defType
        );
        var defs = [];
        ids ? defs.push(ids) : defs.push(definition[0].id);
        var model;
        if (ids && ids.length) {
            model = {
                content: [
                    {
                        key: "algemeen-actief",
                        and_or: "AND",
                        values: [],
                        datatype: "BOOLEAN",
                    },
                ],
                context: [
                    {
                        role: "Maatregel zit in folder",
                        instance_identifiers: ids,
                        direction: "from",
                        and_or: "AND",
                        start: "2020-11-09T09:56:22.986Z",
                    },
                ],
                sorting: [],
                definitions: [definition[0].id], //[process.env.REACT_APP_CATALOG_M_UNITS],
            };
            // this.setState({ lastUsedTableFilter: model });
        } else {
            model = {
                content: [
                    {
                        key: "algemeen-actief",
                        and_or: "AND",
                        values: [true],
                        datatype: "BOOLEAN",
                    },
                ],
                definitions: defs,
                text_search: text_search,
                sorting: sorting,
                instance_identifications: []
                // instance_identifications: window.$set_selected_button_selected_ids
            };
        }
        window.$mm_management_units_lastUsedTableFilterModal = model;

        omnimap
            .GetEntityListAction(
                model,
                pageNr,
                pageSize,
                window.$mm_management_units_token
            )
            .then(successCallback);
    };

    maatregelenCallback = (result) => {
        if (window.$mm_management_units_maat_page_number === 1) {
            $("#maatregelen-grp-measure").html("");
            if (result.data) {
                document.getElementById(
                    "beheeractiviteit-zoeken-item-total"
                ).innerText = result.data.length;
            } else
                document.getElementById(
                    "beheeractiviteit-zoeken-item-total"
                ).innerText = "0";
        }
        // const m_buttons = []
        $.each(result.data, function (index, row) {
            var btn = '<div class="custom-control custom-checkbox">';
            btn +=
                '<input type="checkbox" class="custom-control-input" name="maatregelen"  id="' +
                row["identification"] +
                '" value="' +
                row["name"] +
                '"/>';
            let code = row.content["algemeen-code"];
            if (typeof code === "undefined") {
                code = "";
            }
            btn +=
                '<label class="custom-control-label" for="' +
                row["identification"] +
                '">' +
                row["name"] +
                " - " +
                code +
                "</label></div>";
            $("#maatregelen-grp-measure").append(btn);

            // const button = (
            //     <div className="custom-control custom-checkbox">
            //         <input
            //             type="checkbox"
            //             class="custom-control-input"
            //             name="maatregelen"
            //             id={row["identification"]}
            //             value={row["name"]}
            //         />
            //         <label class="custom-control-label" form={row["identification"] }>
            //             {
            //                 row["name"] +
            //                 " - " +
            //                 code
            //             }
            //         </label>
            //     </div>
            // )
            // m_buttons.push(button)
        });
        // this.setState({
        //     measure_buttons: m_buttons
        // })
    };

    patronenCallback = (result) => {
        if (window.$mm_management_units_patronen_page_number === 1) {
            $("#patronen-grp").html("");
            // if (result.data) {
            //   document.getElementById(
            //     "beheeractiviteit-zoeken-item-total"
            //   ).innerText = result.data.length;
            // } else
            //   document.getElementById(
            //     "beheeractiviteit-zoeken-item-total"
            //   ).innerText = "0";
        }
        $.each(result.data, function (index, row) {
            var btn = '<div class="custom-control custom-radio">';
            btn +=
                '<input type="radio" class="custom-control-input" name="patronen"  id="' +
                row["identification"] +
                '" value="' +
                row["identification"] +
                '" />';
            btn +=
                '<label class="custom-control-label" for="' +
                row["identification"] +
                '">' +
                row["name"] +
                "</label></div>";
            $("#patronen-grp").append(btn);
        });
    };

    disciplineCallback = (result) => {
        $("#discipline-grp").html("");
        $.each(result.data, function (index, row) {
            var btn = '<div class="custom-control custom-radio">';
            btn +=
                '<input type="radio" class="custom-control-input" name="discipline"  id="' +
                row["identification"] +
                '" value="' +
                row["identification"] +
                '" />';
            btn +=
                '<label class="custom-control-label" for="' +
                row["identification"] +
                '">' +
                row["name"] +
                "</label></div>";
            $("#discipline-grp").append(btn);
        });
    };

    periodenCallback = (result) => {
        if (window.$mm_management_units_perioden_page_number === 1) {
            $("#perioden-grp").html("");
            // if (result.data) {
            //   document.getElementById(
            //     "beheeractiviteit-zoeken-item-total"
            //   ).innerText = result.data.length;
            // } else
            //   document.getElementById(
            //     "beheeractiviteit-zoeken-item-total"
            //   ).innerText = "0";
        }

        $.each(result.data, function (index, row) {
            var btn = '<div class="custom-control custom-radio">';
            btn +=
                '<input type="radio" class="custom-control-input" name="perioden"  id="' +
                row["identification"] +
                '" value="' +
                row["identification"] +
                '" />';
            btn +=
                '<label class="custom-control-label" for="' +
                row["identification"] +
                '">' +
                row["name"] +
                "</label></div>";
            $("#perioden-grp").append(btn);
        });
    };

    gebiedenCallback = (result) => {
        $("#gebieden-grp").html("");
        $.each(result.data, function (index, row) {
            var btn = '<div class="custom-control custom-radio">';
            btn +=
                '<input type="radio" class="custom-control-input" name="gebieden"  id="' +
                row["identification"] +
                '" value="' +
                row["identification"] +
                '"/>';
            btn +=
                '<label class="custom-control-label" for="' +
                row["identification"] +
                '">' +
                row["name"] +
                "</label></div>";
            $("#gebieden-grp").append(btn);
        });
    };

    //** Tabloların sütün aramlarının anlık yapılmasını sağlayan fonsiyon.
    searchFilterColumns(key, searchId) {
        var that = this;
        var model = {
            definitions: [process.env.REACT_APP_MM_M_UNITS],
        };

        omnimap
            .SearchFilterColumnsAction(
                model,
                key,
                searchId,
                window.$mm_management_units_token
            )
            .then((result) => {
                CallBackFunctions.SearchFilterColumnsCallBack(searchId, result);
            })
            .catch((error) => {
                console.log(error);
            });
    }

    /*** ---PROPSTAN GELEN TREE VERİSİ İÇERİSİNDE TIKLANAN Lİ'NİN TÜM ALT DALLARINDAKİ İDLERİ GETİRİR--- ***/
    treeParser = (data, beheereenheid) => {
        const that = this;
        data.forEach(function (element) {
            if (element.parentfolder === beheereenheid) {
                window.$mm_management_units_result.push(element.id);
                if (element.children.length > 0) {
                    that.treeParser(element.children, element.id);
                }
            } else if (element.children && element.children.length > 0) {
                that.treeParser(element.children, beheereenheid);
            }
        });
    };

    /*** ---TABLOYU YENİLEYEN FONKSİYON--- ***/
    ReloadData(page_number, ids, short_type, direction, field, content = []) {
        var model;
        var definitions = [];
        let definition = window.$mm_management_units_definitionList.filter(
            (def) => def["name"] === "beheerobjecten"
        );
        definitions.push(definition[0].id);
        if (!short_type) {
            if (ids && ids.length) {
                model = {
                    content: content,
                    context: [
                        {
                            role: "Beheerobject zit in folder",
                            instance_identifiers: ids,
                            direction: "from",
                            and_or: "AND",
                            start: "2020-11-09T09:56:22.986Z",
                        },
                    ],
                    statuses: [],
                    definitions: definitions,
                };
            } else {
                model = {
                    content: content,
                    definitions: definitions,
                    statuses: [],
                };
                window.$mm_management_units_result = [];
            }
        } else if (short_type) {
            if (ids && ids.length) {
                model = {
                    content: content,
                    context: [
                        {
                            role: "Beheerobject zit in folder",
                            instance_identifiers: ids,
                            direction: "from",
                            and_or: "AND",
                            start: "2020-11-09T09:56:22.986Z",
                        },
                    ],
                    sorting: [
                        {
                            sort_type: short_type,
                            direction: direction,
                            field: field,
                        },
                    ],
                    definitions: definitions,
                };
            } else {
                model = {
                    content: content,
                    definitions: definitions,
                    sorting: [
                        {
                            sort_type: short_type,
                            direction: direction,
                            field: field,
                        },
                    ],
                };
            }
        }

        this.setState({lastUsedTableFilter: model});
        this.fillTable(model, page_number);
        this.fillFilterColumns();
    }

    fillFilterColumns(tableType) {
        var that = this;
        var definitions = [];
        definitions.push(tableType);
        var model = {
            definitions: [process.env.REACT_APP_MM_M_UNITS],
        };
        $.each(
            window.$mm_management_units_columnList,
            async function (index, data) {
                if (data.id != "") {
                }
            }
        );
    }

    componentWillUnmount() {
        // window.removeEventListener("scroll", this.handleScroll);
    }

    componentDidUpdate(prevProps, prevState) {
        const that = this;
        window.$mm_management_units_cat_beheerenden_page_number = 1;
        if (!that.props.location.state) {
            if (that.props.location.isDidUpdate !== prevProps.location.isDidUpdate) {
                var model = {
                    content: [],
                    definitions: [process.env.REACT_APP_CATALOG_M_UNITS],
                };
                // that.setState({ lastUsedTableFilter: model });
                that.ReloadData(1);
                document.getElementById("tree-parent-id").setAttribute("value", "");

                var treeClass = document.querySelector(".tree li.open.act");
                var treeDivClass = document.querySelector(".tree li div.open.act");
                if (treeClass !== null) {
                    treeClass.removeAttribute("class");
                }
                if (treeDivClass !== null) {
                    treeDivClass.classList.remove("open");
                    treeDivClass.classList.remove("act");
                }
            } else {
                $("#cover-spin").hide(0);
            }
        } else if (that.props.location.state && prevProps.location.state) {
            if (
                that.props.location.state.isDidUpdate !==
                prevProps.location.state.isDidUpdate
            ) {
                if (that.props.location.state.isDidUpdate == "0038") {
                    var model = {
                        content: [],
                        definitions: [process.env.REACT_APP_CATALOG_M_UNITS],
                    };
                    // that.setState({ lastUsedTableFilter: model });
                    that.ReloadData(1);
                } else {
                    window.$mm_management_units_result = [];
                    window.$mm_management_units_result.push(that.props.location.state.id);
                    this.treeParser(
                        that.props.location.state.TreeList,
                        that.props.location.state.id
                    );

                    var content = [
                        {
                            key: "beheereenheid-naam",
                            and_or: "AND",
                            values: [],
                            datatype: "STRING",
                        },
                    ];

                    if (that.props.location.state.treeLocation === "modal-select") {
                        window.$mm_management_units_maat_page_number = 1;

                        this.getEntityList(
                            "maatregelnames",
                            1,
                            30,
                            this.maatregelenCallback,
                            window.$mm_management_units_result
                        );
                    } else
                        that.ReloadData(
                            1,
                            window.$mm_management_units_result,
                            null,
                            null,
                            null,
                            content
                        );
                }
            }
        } else {
            this.treeParser(
                that.props.location.state.TreeList,
                that.props.location.state.id
            );
            window.$mm_management_units_result = [];
            window.$mm_management_units_result.push(that.props.location.state.id);
            this.treeParser(
                that.props.location.state.TreeList,
                that.props.location.state.id
            );
            var content = [
                {
                    key: "beheereenheid-naam",
                    and_or: "AND",
                    values: [],
                    datatype: "STRING",
                },
            ];

            if (that.props.location.state.treeLocation === "modal-select") {
                window.$mm_management_units_maat_page_number = 1;
                this.getEntityList(
                    "maatregelnames",
                    1,
                    30,
                    this.maatregelenCallback,
                    window.$mm_management_units_result
                );
            } else
                that.ReloadData(
                    1,
                    window.$mm_management_units_result,
                    null,
                    null,
                    null,
                    content
                );

            $("#cover-spin").hide(0);
        }
    }

    handleManagementActivity() {
        $("#cover-spin").show(0);
        const el = $("input[name=maatregelen]:checked");
        // const maatregelId = el.attr("id");
        const patroonId = $("input[name=patronen]:checked").attr("id");
        const periodeId = $("input[name=perioden]:checked").attr("id");

        // const _planningsPatroon = $("input[name=planningspatroon]:checked")[0];
        // const _planningsPeriod = $("input[name=planningsperiode]:checked")[0];


        const ids = []

        for (let i = 0; i < el.length; i++) {
            ids.push(el[i].id)
        }

        // const model = {
        //     'maatregel': ids,
        //     'planningsPatroon': patroonId,
        //     'planningsPeriode': periodeId,
        // };

        const selectedIds = GetSelected()

        const model = {
            'action': MAN_MU_CONST.ADD_MEASURE,
            'maatregel_identifications': ids,
            "planningspatroon_identification": patroonId,
            "planningsperiode_identification": periodeId,
            'identifications': selectedIds
        }

        InitiateProcessAction(model, MAN_MU_CONST.END_POINT).then(() => {
            window.$mm_management_units_context.checkNumberOfWorkerRules()
        }).catch((e) => {
            alert('Something went wrong!')
            console.log(e)
            $("#cover-spin").hide(0);
        })
        //
        //
        //
        // const _model = {
        //     "action": MAN_ME_CONST.PLACE_IN_GLOBAL_PLANNING,
        //     "planningspatroon_identification": patroonId,
        //     "planningsperiode_identification": periodeId,
        //     "identifications": selected
        // }
        //
        // console.log(_model)
        //
        // InitiateProcessAction(_model, MAN_ME_CONST.END_POINT).then(()=>{
        //     this.checkNumberOfWorkerRules()
        //
        // }).catch(()=>{
        //     alert('Something went wrong!')
        //     $("#cover-spin").hide(0);
        // })

        // const selectedIds = GetSelected()

        // StartActivity(
        //     model,
        //     selectedIds,
        //     "9f579fe7-e03c-4e61-ac1b-a724b1d61229",
        //     window.$mm_management_units_context.checkNumberOfWorkerRules,
        //     //beheeractiviteitInserted, checkpointtoreturn
        //     window.$mm_management_units_token
        // );
    }

    handleShowSelectedButton() {
        window.$set_selected_button_selected_ids = [];
        window.$mm_setShowSelectedButtonOff();

        window.$mm_setShowSelectedButtonOnClick = () => {
            const selected = GetSelected();
            window.$set_selected_button_selected_ids = MergeUniquely(window.$set_selected_button_selected_ids, selected)

            if (!window.$mm_setShowSelectedButtonToggleState){
                window.$mm_management_units_lastUsedTableFilter.instance_identifications = [];
            } else {
                window.$mm_management_units_lastUsedTableFilter.instance_identifications = window.$set_selected_button_selected_ids;
            }

            this.fillTable(window.$mm_management_units_lastUsedTableFilter,
                1,
                window.$set_selected_button_selected_ids.length === 0 && window.$mm_setShowSelectedButtonToggleState? CONSTS.EMPTY_TABLE_RESPONSE: null).then(()=>{
                SetSelected(window.$set_selected_button_selected_ids)
            });

        }
    }

    async componentDidMount() {
        let callbackForSetSelectedFromMap = function (){};
        this.handleShowSelectedButton();

        let that = this;
        var token;
        $(".w-30").attr("hidden", "true");
        $('div[name ="header"]').attr("hidden", "true");

        /***************************************************************************************/
        /**FREE FORMAT */
        var tableHeaderItems;
        var userColumnResult = await omnimap.GetFreeFormatByIdAction(
            CONSTS.USER_ID_STORE
        );
        // userda column sort id'si varmı ?
        if (userColumnResult.meta.total_found == 0) {
            var user = window.localStorage.getItem("accessToken");
            window.$mm_management_units_column_order_users.client_identification =
                CONSTS.USER_ID_STORE;
            window.$mm_management_units_column_order_users.code =
                CONSTS.USER_ID_STORE;
            window.$mm_management_units_column_order_users.data.users.push({
                user_id: user.identification,
                id_stores: {
                    table_column_order: uuidv4(),
                },
            });
            omnimap
                .GetFreeFormatAction(
                    "",
                    "POST",
                    window.$mm_management_units_column_order_users
                )
                .then(() => {
                    // GC.sleep(1500).then(() => this.fillTable());
                });
        }
        //userda column sort id'si var sa else geç
        else {
            let result = await omnimap.GetFreeFormatByIdAction(
                CONSTS.COLUMN_ORDER_MM_MANAGEMENT_UNIT
            );

            // bu sayfanın column sort'u var mı?
            if (result.meta.total_found == 0) {
                window.$mm_management_units_column_order_post_model.client_identification =
                    CONSTS.COLUMN_ORDER_MM_MANAGEMENT_UNIT;
                window.$mm_management_units_column_order_post_model.code =
                    CONSTS.COLUMN_ORDER_MM_MANAGEMENT_UNIT;

                omnimap
                    .GetFreeFormatAction(
                        "",
                        "POST",
                        window.$mm_management_units_column_order_post_model
                    )
                    .then(() => {
                        // GC.sleep(1500).then(() => this.fillTable());
                    });
            }
            // bu sayfanın column sort'u varsa else'e geç
            else {
                //burada sayfanın column sortları listenelinr ve table th sıralaması yapılır

                let result = await omnimap.GetFreeFormatByIdAction(
                    CONSTS.COLUMN_ORDER_MM_MANAGEMENT_UNIT,
                    "GET"
                );

                await this.setState({
                    columnOrderIdentification: result.data[0].identification,
                    columnOrderReference: result.data[0].reference,
                });

                result = await result.data[0].data.table_sorting.find(
                    (x) => x.name === "mm>management-units"
                );

                tableHeaderItems = await result.column_list.map((item, index) =>
                    item === "checkbox" ? (
                        <th className="sorting_disabled">
                            <span className="checkAll"/>
                            <span className="checkNone" style={{display: "none"}}/>
                        </th>
                    ) : item === "active" ? (
                        <th className="sorting_disabled" style={{width: "1%"}}>
                            <div id="beheer-short-table">
                                <div id="beheer-svg" className="maatregelen-svg"></div>
                                <div id="beheer-snowflake" className="snowflake"></div>
                            </div>
                        </th>
                    ) : (
                        <th key={item}>{item}</th>
                    )
                );
                await this.setState({
                    columnList: tableHeaderItems,
                });
                window.$mm_management_units_columnListPure = result;
            }
        }
        /***************************************************************************************/

        ColumnList.forEach(function (item) {
            if (item.name == "mm>management-units") {
                window.$mm_management_units_columnList = item["column-list"];
            }
        });

        try {
            const accessTokenRequest = {
                scopes: ["user.read", "openid", "profile"],
            };
            var accessToken = null;
            try {
                accessToken = await msalAuth
                    .acquireTokenSilent(accessTokenRequest)
                    .then((response) => {
                        token = response.idToken.rawIdToken;
                        that.setState({token: token});

                        that.setState({isLoading: false});
                        window.$mm_management_units_token = response.idToken.rawIdToken;

                        $(".w-30").removeAttr("hidden");
                        $('div[name ="header"]').removeAttr("hidden");
                        $("#login-error").addClass("d-none");
                        $("#content-mid").removeAttr("hidden");
                    });
            } catch (error) {
                console.log("AquireTokenSilent failure");
                console.log(error);
                that.setState({isLoading: false});
                $("#login-error").removeClass("d-none");
                $("#content-mid").attr("hidden", "true");
                accessToken = await msalAuth
                    .acquireTokenRedirect(accessTokenRequest)
                    .then((response) => {
                        // get access token from response
                        // response.accessToken
                        token = response.idToken.rawIdToken;
                        that.setState({token: token});
                        window.$mm_management_units_token = response.idToken.rawIdToken;
                        $(".w-30").removeAttr("hidden");
                        $('div[name ="header"]').removeAttr("hidden");
                        $("#login-error").addClass("d-none");
                        $("#content-mid").removeAttr("hidden");
                    })
                    .catch((err) => {
                        // handle error
                    });
            }
        } catch (err) {
            var error = {};
            if (typeof err === "string") {
                var errParts = err.split("|");
                error =
                    errParts.length > 1
                        ? {message: errParts[1], debug: errParts[0]}
                        : {message: err};
            } else {
                error = {
                    message: err.message,
                    debug: JSON.stringify(err),
                };
            }

            this.setState({
                user: {},
                isLoading: false,
                error: error,
            });
        }
        // window.addEventListener("scroll", that.handleScroll);

        //$(document).ready(function () {});
        $("#detailSide").addClass("d-none");

        var table = $("#example").DataTable({
            order: [],
            ordering: false,
            orderCellsTop: true,
            fixedHeader: true,
            searching: false,
            paging: false,
            scrollX: true, //"500px",

            scrollCollapse: true,
            scrollY: "calc(100vh - 330px)",
            dom: '<"top"if>t<"bottom"pr><"clear">',
            info: true,
            infoCallback: function (settings, start, end, max, total, pre) {
                return (
                    '<span class="select-item"></span>' +
                    '<span class="total_right"><span id="total-rows" class="total">' +
                    end +
                    "</span> geselecteerd </span>"
                );
            },
            language: {
                paginate: {
                    previous: "Eerste",
                    next: "Laatste",
                },
                select: {
                    rows: '<span class="items">%d </span>items van&nbsp;', //'<span class="items">%d </span>items van&nbsp;',
                },
            },
            columnDefs: [
                {
                    targets: 0,
                    data: null,
                    defaultContent: "",
                    orderable: false,
                    className: "select-checkbox",
                },
            ],
            select: {
                style: "multi+shift",
                selector: "tr",
            },
            // Disable sorting on the sorting_disabled class
            aoColumnDefs: [
                {
                    bSortable: false,
                    aTargets: ["sorting_disabled"],
                },
            ],
            colReorder: {
                fixedColumnsLeft: 1
            },
            stateSave: true,
            stateSaveCallback: function (settings, data) {
                var names = settings.aoColumns;
                if (names[0]) {
                }
                var test_list = [];
                names.forEach((element, index) => {
                    test_list.push(element.sTitle);
                });

                var checkIndex = test_list.findIndex((x) => x.includes("checkAll"));
                test_list[checkIndex] = "checkbox";
                var statusIndex = test_list.findIndex((x) => x.includes("snowflake"));
                test_list[statusIndex] = "active";
                var model = {
                    identification: that.state.columnOrderIdentification,
                    code: CONSTS.COLUMN_ORDER_MM_MANAGEMENT_UNIT,
                    client_identification: CONSTS.COLUMN_ORDER_MM_MANAGEMENT_UNIT,
                    reference: that.state.columnOrderReference,
                    data: {
                        table_sorting: [
                            {
                                name: "mm>management-units",
                                column_list: [],
                            },
                        ],
                    },
                };
                var asd = (model.data.table_sorting.find(
                    (x) => x.name === "mm>management-units"
                ).column_list = test_list);
                omnimap.GetFreeFormatAction(
                    that.state.columnOrderIdentification,
                    "PUT",
                    model
                );

                // var names = table.columns().names();
                console.log(asd);
            },
        });
        // Setup - add a text input to each footer cell
        $("#example thead tr").clone(true).appendTo("#example thead");

        $(table.table().header()).addClass("scrollabe-datatable");

        var tes = (document.getElementsByClassName(
            "scrollabe-datatable"
        )[0].parentElement.id = "scrollabe-datatable-id");

        $("#scrollabe-datatable-id thead tr")
            .clone(true)
            .appendTo("#scrollabe-datatable-id thead");

        /***************************************/
        // for (let i = 0; i < that.state.columnListPure.column_list.length; i++) {
        //   const column = that.state.columnListPure.column_list[i];

        //   if (i > 1) {
        //     // var title = $(this).text();
        //     var row = $.grep(window.$mm_management_units_columnList, function (v) {
        //       return v.name === column;
        //     });
        //     var rowId = row[0].id;
        //     if (row[0].filter == true) {
        //       $(this).html(
        //         '<input type="search" class="col-search" id="' + rowId + '" />'
        //       );
        //       $("input", this).on("keyup change", function () {
        //         if (table.column(i).search() !== this.value) {
        //           table.column(i).search(this.value).draw();
        //         }
        //       });
        //     } else {
        //       $(this).html("");
        //     }
        //   } else if (i == 0) {
        //     //$(this).html( '<div class="popup threedots" onclick="Popup()"><span class="popuptext" id="myPopup"><a class="maatregelen" href="#">Maatregelen</a><a class="locate" href="#">Beheer gebieden</a><a class="map" href="#">Toon op kaart</a><a class="trash-bin" href="#">Verwijderen</a></span></div>' );
        //     $(this).html(
        //       '<div class="popup threedots"><span class="popuptext" id="myPopup"></span></div>'
        //     );
        //   } else if (i == 1) {
        //     $(this).html(
        //       '<div class="refresh"> </div>' +
        //         /**popup filter1 */
        //         '<div class="filter-popup">' +
        //         '  <span class="popuptext" id="beheer-short-table-popup" ></span>' +
        //         "</div>"
        //     );
        //   } else {
        //     $(this).html("");
        //   }
        // }
        /***************************************/

        /******************************************************** */
        $("#scrollabe-datatable-id thead tr:eq(1) th").each(function (i) {
            var title = $(this).text();
            if (title) {
                var row = $.grep(window.$mm_management_units_columnList, function (v) {
                    return v.name === title;
                });
                var rowId = row[0].id;
                if (row[0].filter == true) {
                    $(this).html(
                        '<input type="search" class="col-search" id="' + rowId + '" />'
                    );
                    $("input", this).on("keyup change", function () {
                        if (table.column(i).search() !== this.value) {
                            table.column(i).search(this.value).draw();
                        }
                    });
                } else {
                    $(this).html("");
                }
            } else if (this.innerHTML.includes("checkAll")) {
                //$(this).html( '<div class="popup threedots" onclick="Popup()"><span class="popuptext" id="myPopup"><a class="maatregelen" href="#">Maatregelen</a><a class="locate" href="#">Beheer gebieden</a><a class="map" href="#">Toon op kaart</a><a class="trash-bin" href="#">Verwijderen</a></span></div>' );
                $(this).html(
                    '<div class="popup threedots"><span class="popuptext" id="myPopup"></span></div>'
                );
            } else if (this.innerHTML.includes("snowflake")) {
                $(this).html(
                    '<div class="refresh"> </div>' +
                    /**popup filter1 */
                    '<div class="filter-popup">' +
                    '  <span class="popuptext" id="beheer-short-table-popup" ></span>' +
                    "</div>"
                );
            } else {
                $(this).html("");
            }
        });
        /******************************************************** */

        $("#scrollabe-datatable-id thead").on("click", "th", function () {
            var row_index = table.column(this).index();
            var nRow = $("#scrollabe-datatable-id thead tr")[0];

            if (row_index != undefined && row_index != 0 && row_index != 1) {
                if (
                    this.childNodes[0].className != "popup threedots" &&
                    this.childNodes[0].className != "refresh" &&
                    this.childNodes[0].className != "col-search ui-autocomplete-input" &&
                    this.childNodes[0].id != "beheer-short-table"
                ) {
                    nRow.childNodes.forEach(function (indx) {
                        if (indx.cellIndex != row_index) {
                            indx.className = "sorting_disabled";
                        }
                    });

                    if (this.className == "sorting_disabled") {
                        this.className = "sorting_asc";
                        var row;
                        $.each(
                            window.$mm_management_units_columnList,
                            function (index, data) {
                                if (data.row == row_index) {
                                    row = data;
                                }
                            }
                        );

                        that.ReloadData(
                            1,
                            window.$mm_management_units_result,
                            row.shortType,
                            "ASCENDING",
                            row.shortField,
                            window.$mm_management_units_filterContent
                        );
                    } else if (this.className == "sorting_asc") {
                        this.className = "sorting_desc";
                        var row;
                        $.each(
                            window.$mm_management_units_columnList,
                            function (index, data) {
                                if (data.row == row_index) {
                                    row = data;
                                }
                            }
                        );
                        that.ReloadData(
                            1,
                            window.$mm_management_units_result,
                            row.shortType,
                            "DESCENDING",
                            row.shortField,
                            window.$mm_management_units_filterContent
                        );
                    } else if (this.className == "sorting_desc") {
                        this.className = "sorting_asc";
                        var row;
                        $.each(
                            window.$mm_management_units_columnList,
                            function (index, data) {
                                if (data.row == row_index) {
                                    row = data;
                                }
                            }
                        );
                        that.ReloadData(
                            1,
                            window.$mm_management_units_result,
                            row.shortType,
                            "ASCENDING",
                            row.shortField,
                            window.$mm_management_units_filterContent
                        );
                    }

                    window.$mm_management_units_page_number = 1;
                }
            }
        });

        $("#example tbody").on("click", "tr", function () {
            if ($(".checkAll").attr("style") == "display: none;") {
                $(".checkNone, .checkAll").toggle();
            }
            DropFromSetSelectedButtonIdsIfSelected(this);
        });

        //** select all table
        $("#scrollabe-datatable-id").on("click", ".checkAll", function (e) {
            var table = $("#example").DataTable();
            table.rows().select();

            $(".checkNone, .checkAll").toggle();
        });

        //** unselect all table
        $("#scrollabe-datatable-id").on("click", ".checkNone", function (e) {
            var table = $("#example").DataTable();
            table.rows().deselect();
            $(".checkNone, .checkAll").toggle();
            window.$set_selected_button_selected_ids = []
        });

        $("#example_filter input").addClass("search-input-table1");
        $(".search-input-table1").attr("placeholder", "search text");

        $("#example tbody").on("dblclick", "tr", function () {
            var rowId = $(this).attr("rowId");

            $.each(window.$mm_management_units_Glist, function (index, data) {
                if (data.identification == rowId) {
                    window.$mm_management_units_selectedRow = data;
                    that.props.history.push(
                        "/management-maintenance/management-units/detail/" + rowId,
                        {
                            rowData: data,
                        }
                    );
                }
            });

            // var rowId = $(this).attr("rowId");

            // $.each(window.$mm_management_units_Glist, function (index, data) {
            //   if (data.identification == rowId) {
            //     window.$mm_management_units_selectedRow = data;
            //   }
            // });

            // fillDetail();
            // $("#tableSide").addClass("d-none");
            // $("#detailSide").removeClass("d-none");
        });

        // Option to allow selecting rows by clicking on row besides checkbox.
        // $("#example tbody").on("click", "tr", function () {
        //   $(this).toggleClass("selected");
        // });

        that.ReloadData(1);

        $(".col-search").on("input", function (e) {
            if (this.value == "") {
                addContentAndFillTable($(this).attr("id"), null);
            }
        });

        /**************************************** */
        table.columns().iterator("column", function (ctx, idx) {
            if (
                window.$mm_management_units_columnListPure.column_list[idx] ===
                "checkbox" ||
                window.$mm_management_units_columnListPure.column_list[idx] === "active"
            ) {
            } else {
                $(table.column(idx).header()).append('<span class="sort-icon"/>');
            }
        });
        /**************************************** */

        $(document).on("click", ".action", function () {
            var actionId = $(this).attr("id");

            if (actionId === "mu_toon_dossiers_op_kaart") {
                callbackForSetSelectedFromMap =  GetDataForMapWithSetSelectedCallback(window.$mm_management_units_lastUsedTableFilter, "management-units");
            } else {
                let modalId = window.$mm_management_units_actions.filter(
                    (act) => act["id"] === actionId
                )[0]["modal"];
                $("#" + modalId).modal("show");
            }
        });

        $("#gebied_plaatsen").on("show.bs.modal", function (event) {
            that.getEntityList("gebieden", 1, 30, that.gebiedenCallback);
        });

        $("#beheeractiviteit_toevoegen").on("show.bs.modal", function (event) {
            window.$mm_management_units_maat_page_number = 1;
            that.getEntityList("maatregelnames", 1, 30, that.maatregelenCallback);
            that.getEntityList("planningspatronen", 1, 30, that.patronenCallback);
            that.getEntityList("planningsperioden", 1, 30, that.periodenCallback);
        });

        $("#beheeractiviteit_toevoegen").on("hide.bs.modal", function () {
            $("#maatregelen-grp-measure").html('')
        });

        $("#discipline_wijzigen").on("show.bs.modal", function (event) {
            that.getEntityList("discipline", 1, 30, that.disciplineCallback);
        });

        $(document).on(
            "click",
            "#maatregelen-grp-measure .custom-control-input",
            function () {
                if ($(this).attr("type") == "checkbox") {
                    let checkboxes = $(".custom-control-input");
                    let checked = 0,
                        un_checked = 0;
                    $.each(checkboxes, function (index, row) {
                        row.checked ? ++checked : ++un_checked;
                    });

                    document.getElementById(
                        "beheeractiviteit-zoeken-item-selected"
                    ).innerText = checked + " ";
                }
            }
        );
        $(document).on("click", "#boom-list .custom-control-input", function () {
            if ($(this).attr("type") == "checkbox") {
                let checkboxes = $(".custom-control-input");
                let checked = 0,
                    un_checked = 0;
                $.each(checkboxes, function (index, row) {
                    row.checked ? ++checked : ++un_checked;
                });

                document.getElementById("boom-item-selected").innerText = checked + " ";
            }
        });

        $("#save_gebied").click(function () {
            $("#cover-spin").show(0);

            const gebiedId = $("input[name=gebieden]:checked").attr("id");

            // var model = {
            //     action: "KOPPEL",
            //     gebied: gebiedId,
            // };

            // var selectedIds = [];
            // $("#example")
            //     .dataTable()
            //     .$("tr.selected")
            //     .each(function () {
            //         selectedIds.push($(this).attr("rowId"));
            //     });

            // StartActivity(
            //     model,
            //     selectedIds,
            //     "94ea165f-4df5-4fad-8566-41b42eb8d493",
            //     gebiedenSaved,
            //     token
            // );
            
            if(!gebiedId){
                alert("map is niet geselecteerd")
                $("#cover-spin").hide(0);
                return;
            }

            const model = {
                'action': MAN_MU_CONST.PLACE_IN_AREA,
                'gebied_identification': gebiedId,
                'identifications': GetSelected()
            }

            InitiateProcessAction(model, MAN_MU_CONST.END_POINT).then(()=>{
                gebiedenSaved()
            }).catch(()=>{
                alert('Something went wrong!')
                $("#cover-spin").hide(0);
            })
        });

        $("#save_discipline").click(function () {
            $("#cover-spin").show(0);
            const disciplineId = $("input[name=discipline]:checked").attr("id");

            // const model = {discipline: disciplineId};
            // const selectedIds = [];
            // $("#example")
            //     .dataTable()
            //     .$("tr.selected")
            //     .each(function () {
            //         selectedIds.push($(this).attr("rowId"));
            //     });

            // StartActivity(
            //     model,
            //     selectedIds,
            //     "3dcddc6d-77da-4b4b-8f48-534241a3804e",
            //     disciplineSaved,
            //     token
            // );

            if(!disciplineId){
                alert("map is niet geselecteerd")
                $("#cover-spin").hide(0);
                return;
            }

            const model = {
                'action': MAN_MU_CONST.CHANGE_DISCIPLINE,
                'discipline_identification': disciplineId,
                'identifications': GetSelected()
            }

            InitiateProcessAction(model, MAN_MU_CONST.END_POINT).then(()=>{
                disciplineSaved()
            }).catch(()=>{
                alert('Something went wrong!')
                $("#cover-spin").hide(0);
            })
        });
        that = this;

        //$("#toevoegen_beheeractiviteit").click();
        // $(document).on("click", ".showMap", function () {
        //   getDataForMap();
        // });

        function uuidv4() {
            return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
                /[xy]/g,
                function (c) {
                    var r = (Math.random() * 16) | 0,
                        v = c == "x" ? r : (r & 0x3) | 0x8;
                    return v.toString(16);
                }
            );
        }
        $(".refresh").click(window.$mm_management_units_context.refresh_);
        $(".showMap").click(function () {
            alert("show map");
        });
        $(".back-page-link").click(function () {
            $("#tableSide").removeClass("d-none");
            $("#detailSide").addClass("d-none");
        });

        $("div.popup").click(function () {
            var selectedIds = [];
            $("#example")
                .dataTable()
                .$("tr.selected")
                .each(function () {
                    selectedIds.push($(this).attr("rowId"));
                });
            GetActionsOfRow(selectedIds.join(","));
        });

        $("#algemeen-gisratioid").autocomplete({
            source: window.$mm_management_units_algemeenGisratioid,
            select: function (event, ui) {
                addContentAndFillTable("algemeen-gisratioid", ui.item.value);
            },
            open: function (e, ui) {
                $(".ui-autocomplete").css(
                    "top",
                    $("ul.ui-autocomplete").cssUnit("top")[0] + 2
                );
            },
        });
        $("#beheereenheid-naam").autocomplete({
            source: window.$mm_management_units_beheereenheidNaam,
            select: function (event, ui) {
                addContentAndFillTable("beheereenheid-naam", ui.item.value);
            },
            open: function (e, ui) {
                $(".ui-autocomplete").css(
                    "top",
                    $("ul.ui-autocomplete").cssUnit("top")[0] + 2
                );
            },
        });
        $("#discipline-naam").autocomplete({
            source: window.$mm_management_units_disciplineNaam,
            select: function (event, ui) {
                addContentAndFillTable("discipline-naam", ui.item.value);
            },
            open: function (e, ui) {
                $(".ui-autocomplete").css(
                    "top",
                    $("ul.ui-autocomplete").cssUnit("top")[0] + 2
                );
            },
        });
        $("#gebied-naam").autocomplete({
            source: window.$mm_management_units_gebiedNaam,
            select: function (event, ui) {
                addContentAndFillTable("gebied-naam", ui.item.value);
            },
            open: function (e, ui) {
                $(".ui-autocomplete").css(
                    "top",
                    $("ul.ui-autocomplete").cssUnit("top")[0] + 2
                );
            },
        });
        $("#algemeen-laag").autocomplete({
            source: window.$mm_management_units_algemeenLaag,
            select: function (event, ui) {
                addContentAndFillTable("algemeen-laag", ui.item.value);
            },
            open: function (e, ui) {
                $(".ui-autocomplete").css(
                    "top",
                    $("ul.ui-autocomplete").cssUnit("top")[0] + 2
                );
            },
        });

        $("#algemeen-gisratioid").on("input", function () {
            // window.$mm_management_units_algemeenGisratioid.length = 0;
            that.searchFilterColumns($(this).val(), this.id);
            // get the current value of the input field.
        });
        $("#beheereenheid-naam").on("input", function () {
            // window.$mm_management_units_beheereenheidNaam.length = 0;
            that.searchFilterColumns($(this).val(), this.id);
            // get the current value of the input field.
        });
        $("#discipline-naam").on("input", function () {
            // window.$mm_management_units_disciplineNaam.length = 0;
            that.searchFilterColumns($(this).val(), this.id);
            // get the current value of the input field.
        });
        $("#gebied-naam").on("input", function () {
            // window.$mm_management_units_gebiedNaam.length = 0;
            that.searchFilterColumns($(this).val(), this.id);
            // get the current value of the input field.
        });
        $("#algemeen-laag").on("input", function () {
            // window.$mm_management_units_algemeenLaag.length = 0;
            that.searchFilterColumns($(this).val(), this.id);
            // get the current value of the input field.
        });
        const _this = this
        /** ekranın herhangi biryerine tıklanınca popup kaldırma için kullanılan fonksiyon */
        $(document)
            .unbind("mouseup")
            .mouseup(function (e) {
                var popup = $("#myPopup");
                if (
                    !$("div.popup").is(e.target) &&
                    !popup.is(e.target) &&
                    popup.has(e.target).length == 0
                ) {
                    $("#myPopup").html("");
                    var popup = document.getElementById("myPopup");
                    $("#myPopup").removeClass("show");

                    // _this.setState({
                    //     measure_buttons: []
                    // })
                }
                var popup = $("#beheer-short-table-popup");
                if (
                    !$("div.filter-popup").is(e.target) &&
                    !popup.is(e.target) &&
                    popup.has(e.target).length === 0
                ) {
                    // $("#beheer-short-table-popup").html("");
                    var popup = document.getElementById("beheer-short-table-popup");
                    $("#beheer-short-table-popup").removeClass("show");
                }
            });

        function gebiedenSaved() {
            sleep(1000).then(() => {
                $("#gebied_plaatsen").modal("hide");
                that.fillTable(window.$mm_management_units_lastUsedTableFilter, 1);
                //window.$mm_management_units_refresh();
            });
        }

        function disciplineSaved() {
            sleep(1000).then(() => {
                $("#discipline_wijzigen").modal("hide");
                that.fillTable(window.$mm_management_units_lastUsedTableFilter, 1);
                //window.$mm_management_units_refresh();
            });
        }

        function beheeractiviteitInserted() {
            sleep(500).then(() => {
                $("#beheeractiviteit_toevoegen").modal("hide");
                that.fillTable(window.$mm_management_units_lastUsedTableFilter, 1);
            });
        }

        //**********************************
        function sleep(time) {
            return new Promise((resolve) => setTimeout(resolve, time));
        }

        /*** ---SERCH INPUTLARDA ARANAN DEĞERİ GETİREN FONKSİYON--- ****/
        function addContentAndFillTable(key, value) {
            var hasRow = $.grep(
                window.$mm_management_units_filterContent,
                function (v) {
                    return v.key === key;
                }
            );
            if (hasRow.length > 0) {
                window.$mm_management_units_filterContent = $.grep(
                    window.$mm_management_units_filterContent,
                    function (value) {
                        return value != hasRow[0];
                    }
                );
            }
            if (value != null) {
                var values = [];
                values.push(value);
                var contentModel = {
                    and_or: "AND",
                    datatype: "STRING",
                    key: key,
                    values: values,
                };
                window.$mm_management_units_filterContent.push(contentModel);
            }
            var definitions = [];
            let definition = window.$mm_management_units_definitionList.filter(
                (def) => def["name"] === "beheerobjecten"
            );
            definitions.push(definition[0].id);
            var model = {
                content: window.$mm_management_units_filterContent,
                definitions: definitions,
            };

            window.$mm_management_units_lastUsedTableFilter = model;

            that.ReloadData(
                1,
                window.$mm_management_units_result,
                null,
                null,
                null,
                window.$mm_management_units_filterContent
            );
            // that.fillTable(model, 1);
        }

        function fillDetail() {
            $("#algemeenGisratioid").html(
                window.$mm_management_units_selectedRow.algemeenGisratioid
            );
            $("#beheereenheidNaam").html(
                window.$mm_management_units_selectedRow.beheereenheidNaam
            );
            $("#code").html(window.$mm_management_units_selectedRow.code);
            $("#laag").html(window.$mm_management_units_selectedRow.laag);
            $("#Gebiedscode").html(
                window.$mm_management_units_selectedRow.Gebiedscode
            );
            $("#gebiedNaam").html(window.$mm_management_units_selectedRow.gebiedNaam);
            $("#startDate").attr(
                "placeholder",
                window.$mm_management_units_selectedRow.startDate
            );
            $("#endDate").attr(
                "placeholder",
                window.$mm_management_units_selectedRow.endDate
            );
            $("#discipline").html(window.$mm_management_units_selectedRow.discipline);
            $("#prestatie").html(window.$mm_management_units_selectedRow.prestatie);
        }

        async function GetActionsOfRow(rowIds) {
            // let roleBasedActionList = await GC.GetActionListByUserRole(process.env.REACT_APP_MM_M_UNITS);

            const actionList = await GetActionsOfEndpointAction(MAN_MU_CONST.END_POINT)

            CallBackFunctions.GetActionsOfRowCallback(actionList)

            // let result = await omnimap
            //     .GetActionsOfRowAction(rowIds, window.$mm_management_units_token)
            //     .catch((error) => {
            //         console.log(error);
            //     });
            //
            // CallBackFunctions.GetActionsOfRowCallback(result);
        }


        // function getDataForMap() {
        //
        //
        //     var model = window.$mm_management_units_lastUsedTableFilter;
        //     var locations = [];
        //     var highlightedIds = [];
        //
        //     omnimap
        //         .GetDataForMapAction(model, window.$mm_management_units_token)
        //         .then((result) => {
        //             if (result.data.length > 0) {
        //                 var selectedIds = [];
        //                 $("#example")
        //                     .dataTable()
        //                     .$("tr.selected")
        //                     .each(function () {
        //                         selectedIds.push($(this).attr("rowId"));
        //                     });
        //
        //                 for (const data of result.data) {
        //                     locations.push(data.location);
        //                     if (selectedIds.includes(data.identification)) {
        //                         for (var i = 0; i < data.location.features.length; i++) {
        //                             highlightedIds.push(
        //                                 data.location.features[i].properties.identifier
        //                             );
        //                         }
        //                     }
        //                 }
        //                 if (window.$mm_management_units_webgisId == "") {
        //                     window.$mm_management_units_webgisId = uuidv4();
        //                     var win = window.open(
        //                         "/gispublisher.html?webgisId=" +
        //                         window.$mm_management_units_webgisId,
        //                         "_blank"
        //                     );
        //                     /* $(win).ready(function () {
        //                       $(win.document).on("click", "#mommy", async function () {
        //                         await localStorage.setItem("webgis", "");
        //                         await localStorage.setItem(
        //                           "webgis",
        //                           JSON.stringify({
        //                             type: "addFeatures",
        //                             locations: locations,
        //                           })
        //                         );
        //
        //                         await localStorage.setItem("webgis", "");
        //                         await localStorage.setItem(
        //                           "webgis",
        //                           JSON.stringify({
        //                             type: "highlightFeatures",
        //                             featureIds: highlightedIds,
        //                           })
        //                         );
        //                       });
        //                     }); */
        //
        //                     localStorage.setItem(
        //                         "webgis",
        //                         JSON.stringify({
        //                             type: "addFeatures",
        //                             locations: locations,
        //                             featureIds: highlightedIds,
        //                         })
        //                     );
        //                 } else {
        //                     /* localStorage.setItem("webgis", "");
        //                     localStorage.setItem(
        //                       "webgis",
        //                       JSON.stringify({ type: "addFeatures", locations: locations })
        //                     );
        //
        //                     localStorage.setItem("webgis", "");
        //                     localStorage.setItem(
        //                       "webgis",
        //                       JSON.stringify({
        //                         type: "highlightFeatures",
        //                         featureIds: highlightedIds
        //                       })
        //                     ); */
        //
        //                     localStorage.setItem("webgis", "");
        //                     localStorage.setItem(
        //                         "webgis",
        //                         JSON.stringify({
        //                             type: "addFeatures",
        //                             locations: locations,
        //                             featureIds: highlightedIds,
        //                         })
        //                     );
        //                 }
        //             }
        //         });
        //
        //     // $.ajax({
        //     //   type: "POST",
        //     //   url:
        //     //     "https://" +
        //     //     process.env.REACT_APP_BASE_URL +
        //     //     "/omnimap/search/?page-size=30&page-number=1&includes=PROPERTIES,MONITORING,CONTENT,CONTEXT,LOCATIONS",
        //     //   beforeSend: function (request) {
        //     //     request.setRequestHeader(
        //     //       "Authorization",
        //     //       "Bearer " + that.state.token
        //     //     );
        //     //     request.setRequestHeader(
        //     //       "tenant_identification",
        //     //       process.env.REACT_APP_TENANT_IDENTIFICATION
        //     //     );
        //     //     request.setRequestHeader(
        //     //       "organisation_identification",
        //     //       process.env.REACT_APP_ORGANISATION_IDENTIFICATION
        //     //     );
        //     //   },
        //     //   contentType: "application/json",
        //     //   dataType: "json",
        //     //   data: JSON.stringify(model),
        //     //   success: function (result) {
        //
        //     //   },
        //     //   error: function (err) {
        //     //     //alert("Ajax call not success, no data retreived");
        //     //   },
        //     // });
        // }

        /*****BEGIN --FILTER ICON CLICK--- BEGIN*****/
        $("#beheer-short-table").click(function () {
            if (!window.$mm_management_units_filterClickStatus) {
                $("#myPopup").html("");
                $("#beheer-short-table-popup").html("");
                var filterRowActive = $('<div id="beheer-filter-input-true"></div>')
                    .attr({name: "true"})
                    .addClass("filter-popup-r")
                    .html(
                        '<label class="filter-container" id="filter-container-true">Filter op met maatregel' +
                        '<input type="checkbox" name="filter-input" id="m-filter-input-true">' +
                        '<span class="checkmark-green"></span>' +
                        "</label>"
                    );

                var filterRowFalse = $('<div id="beheer-filter-input-false"></div>')
                    .attr({name: "false"})
                    .addClass("filter-popup-r")
                    .html(
                        '<label class="filter-container" id="filter-container-false">Filter op zonder maatregel' +
                        '<input type="checkbox" name="filter-input"  id="m-filter-input-false">' +
                        '<span class="checkmark-red"></span>' +
                        "</label>"
                    );
                $("#beheer-short-table-popup").append(filterRowActive, filterRowFalse);
                window.$mm_management_units_filterClickStatus = true;
            }

            var popup = document.getElementById("beheer-short-table-popup");
            popup.classList.toggle("show");
        });
        /*****END FILTER ICON CLICK END*****/

        /*****BEGIN FILTER MAATREGELEN CHECKBOX FUNCTIONS  BEGIN*****/

        $(document).on("click", "label#filter-container-true", async function () {
            if (window.$mm_management_units_gvv == 0) {
                window.$mm_management_units_filterCheckControl[0] =
                    !window.$mm_management_units_filterCheckControl[0];
                window.$mm_management_units_filterCheckControl[1] = false;
                console.log(window.$mm_management_units_filterCheckControl);
                if (
                    !window.$mm_management_units_filterCheckControl[0] &&
                    !window.$mm_management_units_filterCheckControl[1]
                ) {
                    that.ReloadData(1);
                    $("#beheer-svg").attr("class", "maatregelen-svg");
                    $("#beheer-snowflake").attr("class", "snowflake");
                    window.$mm_management_units_gvv++;
                } else {
                    document.getElementById("beheer-filter-input-false").remove();

                    $("#beheer-svg").attr("class", "maatregelen-svg-green");
                    $("#beheer-snowflake").attr("class", "snowflake-green");
                    var filterRowFalse = $('<div id="beheer-filter-input-false""></div>')
                        .attr({name: "false"})
                        .addClass("filter-popup-r")
                        .html(
                            '<label class="filter-container" id="filter-container-false">Filter op zonder maatregel' +
                            '<input type="checkbox" name="filter-input" id="m-filter-input-false">' +
                            '<span class="checkmark-red"></span>' +
                            "</label>"
                        );
                    $("#beheer-short-table-popup").append(filterRowFalse);
                    window.$mm_management_units_gvv++;
                    window.$mm_management_units_filterMaatregelenIsActive = [true];

                    var hasRow = $.grep(
                        window.$mm_management_units_filterContent,
                        function (v) {
                            if (v.values[0] == false) {
                                return v.key === "status-beheeractiviteit";
                            } else if (v.values[0] == true) {
                                return v.key === "status-beheeractiviteit";
                            }
                        }
                    );
                    if (hasRow.length > 0) {
                        window.$mm_management_units_filterContent = $.grep(
                            window.$mm_management_units_filterContent,
                            function (item) {
                                if (item.values[0] == false) {
                                    return item !== hasRow[0];
                                }
                            }
                        );
                    }

                    var model = {
                        key: "status-beheeractiviteit",
                        and_or: "AND",
                        values: window.$mm_management_units_filterMaatregelenIsActive,
                        datatype: "BOOLEAN",
                    };
                    window.$mm_management_units_filterContent.push(model);
                    window.$mm_management_units_page_number = 1;
                    await that.ReloadData(
                        1,
                        null,
                        null,
                        null,
                        null,
                        window.$mm_management_units_filterContent
                    );
                }
            }
        });

        $(document).on("click", "label#filter-container-false", async function () {
            if (window.$mm_management_units_gvv == 0) {
                window.$mm_management_units_filterCheckControl[1] =
                    !window.$mm_management_units_filterCheckControl[1];
                window.$mm_management_units_filterCheckControl[0] = false;
                console.log(window.$mm_management_units_filterCheckControl);
                if (
                    !window.$mm_management_units_filterCheckControl[0] &&
                    !window.$mm_management_units_filterCheckControl[1]
                ) {
                    that.ReloadData(1);
                    $("#beheer-svg").attr("class", "maatregelen-svg");
                    $("#beheer-snowflake").attr("class", "snowflake");
                    window.$mm_management_units_gvv++;
                } else {
                    document.getElementById("beheer-filter-input-true").remove();

                    $("#beheer-svg").attr("class", "maatregelen-svg-red");
                    $("#beheer-snowflake").attr("class", "snowflake-red");
                    var filterRowActive = $('<div id="beheer-filter-input-true"></div>')
                        .attr({name: "true"})
                        .addClass("filter-popup-r")
                        .html(
                            '<label class="filter-container" id="filter-container-true">Filter op met maatregel' +
                            '<input type="checkbox" name="filter-input" id="m-filter-input-true">' +
                            '<span class="checkmark-green"></span>' +
                            "</label>"
                        );

                    $("#beheer-short-table-popup").prepend(filterRowActive);
                    window.$mm_management_units_gvv++;
                    window.$mm_management_units_filterMaatregelenIsActive = [false];

                    var hasRow = $.grep(
                        window.$mm_management_units_filterContent,
                        function (v) {
                            if (v.values[0] == true) {
                                return v.key === "status-beheeractiviteit";
                            } else if (v.values[0] == false) {
                                return v.key === "status-beheeractiviteit";
                            }
                        }
                    );
                    if (hasRow.length > 0) {
                        window.$mm_management_units_filterContent = $.grep(
                            window.$mm_management_units_filterContent,
                            function (item) {
                                if (item.values[0] == true) {
                                    return item !== hasRow[0];
                                }
                            }
                        );
                    }

                    var model = {
                        key: "status-beheeractiviteit",
                        and_or: "AND",
                        values: window.$mm_management_units_filterMaatregelenIsActive,
                        datatype: "BOOLEAN",
                    };
                    window.$mm_management_units_filterContent.push(model);

                    window.$mm_management_units_page_number = 1;
                    await that.ReloadData(
                        1,
                        null,
                        null,
                        null,
                        null,
                        window.$mm_management_units_filterContent
                    );
                }
            }
        });
        /*****END FILTER MAATREGELEN CHECKBOX FUNCTIONS END*****/

        /***MODAL SCROLL END OF BOTTOM***/
        $("#maatregelen-grp-measure").scroll(function () {
            var buffer = 0; // # of pixels from bottom of scroll to fire your function. Can be 0
            if (
                $("#maatregelen-grp-measure").prop("scrollHeight") -
                $("#maatregelen-grp-measure").scrollTop() <=
                $("#maatregelen-grp-measure").height() + buffer
            ) {
                window.$mm_management_units_maat_page_number++;

                that.getEntityList(
                    "maatregelnames",
                    window.$mm_management_units_maat_page_number,
                    30,
                    that.maatregelenCallback,
                    null,
                    window.$mm_management_units_text_search,
                    window.$mm_management_units_sorting
                );
                let checkboxes = $("#maatregelen-grp-measure .custom-control-input");

                document.getElementById(
                    "beheeractiviteit-zoeken-item-total"
                ).innerText = checkboxes.length;
            }
        });
        $("#patronen-grp").scroll(function () {
            var buffer = 0; // # of pixels from bottom of scroll to fire your function. Can be 0
            if (
                $("#patronen-grp").prop("scrollHeight") -
                $("#patronen-grp").scrollTop() <=
                $("#patronen-grp").height() + buffer
            ) {
                window.$mm_management_units_patronen_page_number++;
                that.getEntityList(
                    "planningspatronen",
                    window.$mm_management_units_patronen_page_number,
                    30,
                    that.patronenCallback
                );
                // let checkboxes = $(".custom-control-input");

                // document.getElementById(
                //   "beheeractiviteit-zoeken-item-total"
                // ).innerText = checkboxes.length;
            }
        });
        $("#perioden-grp").scroll(function () {
            var buffer = 0; // # of pixels from bottom of scroll to fire your function. Can be 0
            if (
                $("#perioden-grp").prop("scrollHeight") -
                $("#perioden-grp").scrollTop() <=
                $("#perioden-grp").height() + buffer
            ) {
                window.$mm_management_units_perioden_page_number++;
                that.getEntityList(
                    "planningsperioden",
                    window.$mm_management_units_perioden_page_number,
                    30,
                    that.periodenCallback
                );
                // let checkboxes = $(".custom-control-input");
                // document.getElementById(
                //   "beheeractiviteit-zoeken-item-total"
                // ).innerText = checkboxes.length;
            }
        });
        /***MODAL SCROLL END OF BOTTOM***/

        /***MODAL SCROLL END OF BOTTOM***/
        $(".dataTables_scrollBody").scroll(function () {
            var buffer = 0.33; // # of pixels from bottom of scroll to fire your function. Can be 0
            if (window.$mm_management_units_scroll_change) {
                if (
                    $(".dataTables_scrollBody").prop("scrollHeight") -
                    $(".dataTables_scrollBody").scrollTop() <=
                    $(".dataTables_scrollBody").height() + buffer
                ) {
                    if (document.getElementById("tableSide").className !== "d-none") {
                        if (
                            `/${this.baseURI.split("/")[3]}/${this.baseURI.split("/")[4]}` ===
                            that.props.location.pathname &&
                            window.$mm_management_units_table_total_row_count >
                            process.env.REACT_APP_TABLE_TOTAL_ROW_COUNT
                        ) {
                            $("#cover-spin").show(0);
                            window.$mm_management_units_page_number++;
                            // Here adds more rows at the end of the table when scrolled all

                            that.fillTable(
                                window.$mm_management_units_lastUsedTableFilter,
                                window.$mm_management_units_page_number
                            ).then(()=> {
                                window.$set_selected_button_selected_ids = MergeUniquely(window.$set_selected_button_selected_ids, callbackForSetSelectedFromMap())
                            });
                        }
                    } else window.$mm_management_units_scroll_change = true;
                }
            }
        });

        $("#beheeractiviteit-zoeken-input").on("input", function () {
            window.$mm_management_units_maat_page_number = 1;
            document.getElementById(
                "beheeractiviteit-zoeken-item-selected"
            ).innerText = "0 ";
            window.$mm_management_units_text_search = [
                {
                    text_query: $(this).val(),
                    search_fields: ["NAME", "IDENTIFIER", "IDENTIFICATION", "CONTENT"],
                    fuzzy: true,
                    and_or: "OR",
                },
            ];
            window.$mm_management_units_sorting = [
                {sort_type: "text_score", direction: "DESCENDING"},
            ];
            if ($(this).val() == "") {
                window.$mm_management_units_text_search = [];
                window.$mm_management_units_sorting = [];
            }
            that.getEntityList(
                "maatregelnames",
                1,
                30,
                that.maatregelenCallback,
                null,
                window.$mm_management_units_text_search,
                window.$mm_management_units_sorting
            );
        });
        $("#planningsperiode").on("input", function () {
            let text_search = [
                {
                    text_query: $(this).val(),
                    search_fields: ["NAME"],
                    fuzzy: true,
                    and_or: "OR",
                },
            ];
            let sorting = [{sort_type: "text_score", direction: "DESCENDING"}];

            if ($(this).val() == "") {
                text_search = [];
                sorting = [];
            }
            that.getEntityList(
                "planningsperioden",
                1,
                30,
                that.periodenCallback,
                null,
                text_search,
                sorting
            );
        });
        $("#planningspatroon").on("input", function () {
            let text_search = [
                {
                    text_query: $(this).val(),
                    search_fields: ["NAME"],
                    fuzzy: true,
                    and_or: "OR",
                },
            ];
            let sorting = [{sort_type: "text_score", direction: "DESCENDING"}];
            if ($(this).val() == "") {
                text_search = [];
                sorting = [];
            }
            that.getEntityList(
                "planningspatronen",
                1,
                30,
                that.patronenCallback,
                null,
                text_search,
                sorting
            );
        });

        var model = {
            content: [
                {
                    key: "algemeen-isvoor",
                    and_or: "AND",
                    values: ["maatregelen"],
                    datatype: "STRING",
                },
            ],
            context: [],
            timestamps: [],
            definitions: [process.env.REACT_APP_TREE],
            statuses: [],
        };
        GetTreeStructure("", model, that.state.token, true).then(function (
            TreeResult
        ) {
            if (TreeResult) {
                // that.state.treeList = TreeResult.treeList;
                that.setState({treeList: TreeResult.treeList});
            }
        });
    }

    render() {
        //Datatable HTML
        if (this.state.isLoading) {
            return (
                <>
                    <div
                        style={{position: "fixed", top: "30%", left: "50%", right: "50%"}}
                    >
                        <CommonLoading/>
                    </div>
                </>
            );
        }
        return (
            <div id="tableSide">
                <table id="example" className="table-hover table min-full-width">
                    <thead>
                    <tr>{this.state.columnList}</tr>
                    </thead>
                    <tbody></tbody>
                </table>
                <input id="tree-parent-id" hidden/>
                <input id="tree-parent-name" hidden/>
                <div>
                    <div
                        className="modal fade"
                        tabIndex={-1}
                        role="dialog"
                        id="gebied_plaatsen"
                    >
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Plaats in gebied</h5>
                                    <button
                                        type="button"
                                        className="close"
                                        data-dismiss="modal"
                                        aria-label="Close"
                                    />
                                </div>
                                <div className="modal-body">
                                    <input
                                        type="search"
                                        className="modal-search"
                                        placeholder="Zoeken naar gebieden"
                                    />
                                    <div className="modal-scroll">
                                        <div id="gebieden-grp" className="radio-grp"/>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" id="save_gebied" className="btn-modal">
                                        Verwerken
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        className="modal fade"
                        tabIndex={-1}
                        role="dialog"
                        id="discipline_wijzigen"
                    >
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Discipline wijzigen</h5>
                                    <button
                                        type="button"
                                        className="close"
                                        data-dismiss="modal"
                                        aria-label="Close"
                                    />
                                </div>
                                <div className="modal-body">
                                    <input
                                        type="search"
                                        className="modal-search"
                                        placeholder="Zoeken naar gebieden"
                                    />
                                    <div className="modal-scroll">
                                        <div id="discipline-grp" className="radio-grp"/>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button
                                        type="button"
                                        id="save_discipline"
                                        className="btn-modal"
                                    >
                                        Verwerken
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        className="modal fade"
                        tabIndex={-1}
                        role="dialog"
                        id="beheeractiviteit_toevoegen"
                    >
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                <div>
                                    <div className="modal-header">
                                        <h5 className="modal-title">Toevoegen maatregel</h5>
                                        <button
                                            type="button"
                                            className="close"
                                            data-dismiss="modal"
                                            aria-label="Close"
                                        />
                                    </div>
                                    <div className="modal-body">
                                        <div className="modal-btn-group">
                                            <button
                                                type="button"
                                                onClick={this.handleToggleZoeken}
                                                className={
                                                    this.state.beheeractiviteit_zoeken_active
                                                        ? "beheeractiviteit-zoeken-focus"
                                                        : "beheeractiviteit-zoeken"
                                                }
                                            >
                                                Zoeken
                                            </button>
                                            <button
                                                type="button"
                                                onClick={this.handleToggleBoom}
                                                className={
                                                    this.state.beheeractiviteit_boom_active
                                                        ? "beheeractiviteit-boom-structuur-focus"
                                                        : "beheeractiviteit-boom-structuur"
                                                }
                                            >
                                                Boomstructuur
                                            </button>
                                        </div>

                                        <div
                                            class={
                                                this.state.beheeractiviteit_zoeken_active
                                                    ? "beheeractiviteit-zoeken-content"
                                                    : "beheeractiviteit-zoeken-content-none"
                                            }
                                        >
                                            <input
                                                id="beheeractiviteit-zoeken-input"
                                                type="search"
                                                className="modal-search"
                                                placeholder="Zoeken"
                                                autocomplete="off"
                                            />
                                        </div>
                                        <div
                                            class={
                                                this.state.beheeractiviteit_boom_active
                                                    ? "beheeractiviteit-boom-content"
                                                    : "beheeractiviteit-boom-content-none"
                                            }
                                        >
                                            <div className="modal-scroll">
                                                <div id="boom-structuur" className="radio-grp">
                                                    <p>Boomstructuur</p>
                                                    <div ref={this.wrapperRef}>
                                                        <MyContext.Consumer>
                                                            {(context) => (
                                                                <div>
                                                                    <TreeChildren
                                                                        TreeList={
                                                                            context.store.treeCount == null
                                                                                ? this.state.treeList
                                                                                : context.store.treeCount !=
                                                                                this.state.treeCount
                                                                                    ? context.store.treeList
                                                                                    : this.state.treeList
                                                                        }
                                                                        componentName="management-units"
                                                                        pathname="management-maintenance"
                                                                        treeLocation="modal-select"
                                                                    />
                                                                </div>
                                                            )}
                                                        </MyContext.Consumer>
                                                    </div>
                                                    <div>
                                                        <TreeChildren
                                                            TreeList={this.state.treeList}
                                                            componentName="management-units"
                                                            pathname="management-maintenance"
                                                            treeLocation="modal"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <p class="beheeractiviteit-zoeken-item">
                                            <span id="beheeractiviteit-zoeken-item-selected">0</span>{" "}
                                            item van
                                            <span id="beheeractiviteit-zoeken-item-total">0</span>{" "}
                                            geselecteerd
                                        </p>
                                        <div className="modal-scroll">
                                            <div id="maatregelen-grp-measure" className="radio-grp">
                                                {/*{this.state.measure_buttons}*/}
                                            </div>
                                        </div>
                                        <span
                                            for="plannig-and-a"
                                            class={
                                                this.state.beheeractiviteit_plannig_active
                                                    ? "btn-plannig open"
                                                    : "btn-plannig"
                                            }
                                        >
                    <input
                        id="plannig-and-a"
                        type="button"
                        className="modal-dropdown"
                        placeholder="Zoeken"
                        value="Planningspatroon & planningsperiode"
                        onClick={this.handlePlannig}
                    />
                  </span>
                                        <div
                                            class={
                                                this.state.beheeractiviteit_plannig_active
                                                    ? "btn-plannig-context"
                                                    : "btn-plannig-context-none"
                                            }
                                        >
                                            <p>Planningspatroon</p>
                                            <input
                                                id="planningspatroon"
                                                type="search"
                                                className="modal-search"
                                                placeholder="Zoeken"
                                            />
                                            <div className="modal-scroll">
                                                <div id="patronen-grp" className="radio-grp"/>
                                            </div>
                                            <p>Planningsperiode</p>
                                            <input
                                                id="planningsperiode"
                                                type="search"
                                                className="modal-search"
                                                placeholder="Zoeken"
                                            />
                                            <div className="modal-scroll">
                                                <div id="perioden-grp" className="radio-grp"/>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="modal-footer">
                                        <button
                                            type="button"
                                            id="toevoegen_beheeractiviteit"
                                            className="btn-modal"
                                            onClick={this.handleManagementActivity}
                                        >
                                            Verwerken
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Table;
